<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Mensagens — Recebidas
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  ler
        | ,
        strong  responder
        | ,
        strong  arquivar
        |  e
        strong  restaurar
        |  mensagens recebidas na
        strong  Caixa de mensagens
        | .

      .toast.toast-primary
        | A caixa fica no menu
        strong  Mensagens
        | , para o usuário autenticado. O número ao lado do menu é a quantidade de mensagens não lidas.

      h5.h5 1. Abrir a caixa
      ol
        li No menu lateral, clique em
          strong  Mensagens
          | .
        li A tela abre em
          strong  Mensagens recebidas
          | . À esquerda ficam
          strong  Mensagens enviadas
          | ,
          strong  Nova mensagem
          |  e
          strong  Novo comunicado interno
          | .

      h5.h5 2. Listagem
      p
        | Filtre pelo
        strong  Título
        |  e clique na lupa (
        strong  Filtrar
        | ). Cada linha mostra o título, o assunto, o remetente (
        strong  De
        | ) e a data de envio.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de mensagens recebidas")
      ul
        li O envelope fechado, em roxo, indica mensagem ainda não lida.
        li O envelope aberto indica mensagem já lida.
        li Clique na linha para abrir a mensagem. Ao abrir, ela passa a contar como lida e o número do menu é atualizado.

      h5.h5 3. Leitura
      figure.manual-figure
        img(:src="imgLeitura" alt="Leitura de mensagem recebida")
      ol
        li A tela mostra título, assunto,
          strong  De
          |  (documento e nome),
          strong  Enviado em
          | ,
          strong  Para
          | ,
          strong  Lido em
          |  e o texto.
        li Se houver anexos, clique na miniatura para abrir o arquivo.
        li Se a conversa tiver mensagens anteriores, use
          strong  Carregar mensagem anterior...
          | .
        li
          strong  Voltar
          |  retorna à lista.

      h5.h5 4. Responder
      p
        | O botão
        strong  Responder
        |  aparece quando a mensagem permite resposta e ainda não está arquivada.
      figure.manual-figure
        img(:src="imgResponder" alt="Resposta de mensagem recebida")
      ol
        li Clique em
          strong  Responder
          | .
        li Escreva o texto em
          strong  Enviar resposta
          | . O campo é obrigatório.
        li Clique em
          strong  Enviar
          | . A confirmação é
          strong  Mensagem respondida
          | .
          strong  Cancelar
          |  fecha o campo sem enviar.

      h5.h5 5. Arquivar e restaurar
      ol
        li Em uma mensagem da caixa de entrada, clique em
          strong  Arquivar
          | .
        li Confirme
          strong  Deseja arquivar a mensagem?
          |  com
          strong  Sim
          | . A mensagem sai da aba
          strong  Mensagens
          |  e vai para
          strong  Arquivadas
          | .
        li Na aba
          strong  Arquivadas
          | , abra a mensagem e clique em
          strong  Restaurar
          | . Confirme
          strong  Deseja restaurar a mensagem?
          | . Ela volta para a caixa de entrada.
      p
        | A aba
        strong  Arquivadas
        |  também filtra por título. O ícone e os dados da linha seguem o mesmo padrão da caixa de entrada.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/46-mensagens-recebidas-lista.png"),
      imgLeitura: require("@/assets/manuais/46a-mensagens-recebidas-leitura.png"),
      imgResponder: require("@/assets/manuais/46b-mensagens-recebidas-responder.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
